import * as React  from 'react'
import { connect } from 'react-redux'

import Grid            from '@material-ui/core/Grid'
import ListItemIcon    from '@material-ui/core/ListItemIcon'
import ListItemText    from '@material-ui/core/ListItemText'
import Menu            from '@material-ui/core/Menu'
import MenuItem        from '@material-ui/core/MenuItem'
import styled, { css } from 'styled-components'

import { changeLocale, Locale, selectLocale } from '../../redux/ducks'
import British                                from '../../resources/flag-icons/english'
import Spanish                                from '../../resources/flag-icons/spanish'
import {indraEnabled} from '../../theme'


const Banner = styled.div`
  position: relative;
  padding: 8px;
  width: 100%;
  background-color: ${({ theme }) => theme.loginHeaderBarColor};
`

interface LogoProps {
  indraEnabled: boolean;
}
const Logo = styled.img<LogoProps>`
  display: block;
  margin: auto;
  height: ${({indraEnabled}) => indraEnabled ? '38px' : '80%'};
  position: absolute;
  left: ${({indraEnabled}) => indraEnabled ? '130px' : '50%'};
  top: 50%;
  transform: translateY(-50%) translateX(-50%);
`

const langIconCSS = css``

const BritishIcon = styled(British)`
  ${langIconCSS}
`

const SpanishIcon = styled(Spanish)`
  ${langIconCSS}
`

/*
 TODO:
 Learn how to properly use typescript with material-ui's withStyles.

 Explained here:
 https://material-ui.com/guides/typescript/
 */

const locales = Object.keys(Locale).map(key => Locale[ key ])

const localeIconMap = {
  es: <SpanishIcon />,
  en: <BritishIcon />,
}

const mstp = state => ({ locale: selectLocale(state) })

const actions = { changeLocale }

type Props =
  typeof actions
  & ReturnType<typeof mstp>

const initState = {
  anchorEl: null as any,
}

class LandingHeader extends React.Component<Props> {
  public state = initState

  public render () {
    const { locale } = this.props

    return (
      <Banner>
        <Logo src={!indraEnabled ? '/assets/logo_login.png' : '/assets/indra.png'} indraEnabled={indraEnabled} />
        <Grid container justify={'flex-end'}>
          <MenuItem onClick={this.handleClick} style={{color: 'white'}}>
            {locale.toUpperCase()}
          </MenuItem>
          <Menu
            open={Boolean(this.state.anchorEl)}
            anchorEl={this.state.anchorEl}
            onClose={this.close}
          >
            {locales.map(locale => (
              <MenuItem
                key={locale}
                onClick={() => {
                  this.handleSelectLocale(locale)
                }}
              >
                <ListItemIcon>
                  {localeIconMap[ locale ]}
                </ListItemIcon>
                <ListItemText primary={locale.toUpperCase()} />
              </MenuItem>
            ))}
          </Menu>
        </Grid>
      </Banner>
    )
  }

  private handleSelectLocale = locale => {
    this.close()
    this.props.changeLocale(locale)
  }

  private close = () => {
    this.setState({
      anchorEl: null,
    })
  }

  private handleClick = ({ target }) => {
    this.setState({
      anchorEl: target,
    })
  }
}

export default connect(mstp, actions)(LandingHeader)



// WEBPACK FOOTER //
// ./src/components/molecules/LandingHeader.tsx